/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React, { Fragment } from 'react';
import useFormApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-form-api';
import { SelectIcon } from '@td-client-frontend/icons';

export const GridForm = ({ fieldArrayRenderProps, isValid, editField, cancel, setViewMode, fields }) => {
  const { renderForm } = useFormApi();

  return (
    <Fragment>
      {fieldArrayRenderProps.fields.map((name, index) => {
        if (name !== editField) {
          // eslint-disable-next-line array-callback-return
          return;
        }
        return (
          <Fragment key={`${name}-${index}`}>
            <button type='button' className='space-x-2 btn btn-default' onClick={setViewMode}>
              <SelectIcon className='inline' transform='rotate(90)' />
              <span className='pl-2 pr-5 text-primary-500'>back</span>
            </button>
            {renderForm(generateFieldsArrayNames(fields, name))}
          </Fragment>
        );
      })}
    </Fragment>
  );
};

function processCondition(condition, prefix) {
  if (!condition) {
    return condition;
  }

  const newCondition = { ...condition };

  if (newCondition.when) {
    newCondition.when = `${prefix}.${newCondition.when}`;
  }

  if (newCondition.and) {
    newCondition.and = newCondition.and.map((subCondition) => processCondition(subCondition, prefix));
  }

  if (newCondition.or) {
    newCondition.or = newCondition.or.map((subCondition) => processCondition(subCondition, prefix));
  }

  return newCondition;
  }

function generateFieldsArrayNames(fields, name) {

  return fields.map((field) => {
    let fields: any;
    if (field.fields) {
      fields = generateFieldsArrayNames(field.fields, name);
    }

    const processedCondition = processCondition(field.condition, name);
    return {
      ...field,
      name: `${name}.${field.name}`,
      condition: processedCondition,
      fields: fields || undefined
    };
  });
}
